import { NgModule } from '@angular/core';

import { CurrencyCentsInputDirective } from '@core/directives/currency-cents-input/currency-cents-input.directive';
import { FeatherIconDirective } from '@core/directives/core-feather-icons/core-feather-icons';
import { RippleEffectDirective } from '@core/directives/core-ripple-effect/core-ripple-effect.directive';
import { CustomIconDirective } from './custom-icons.directive';

@NgModule({
  declarations: [RippleEffectDirective, FeatherIconDirective, CustomIconDirective, CurrencyCentsInputDirective],
  exports: [RippleEffectDirective, FeatherIconDirective, CustomIconDirective, CurrencyCentsInputDirective]
})
export class CoreDirectivesModule {}
